export default "__VITE_ASSET__BNycfdIt__"